import Drawer from 'antd-mobile/lib/drawer';
export default Drawer;



// WEBPACK FOOTER //
// ./components/drawer/index.tsx